import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a6e4a24c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "TextLogicalReasoningRenderContainer"
};
const _hoisted_2 = {
  class: "ft20"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "阅读文字规则，根据规律推断并选出问号处的正确答案", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "请根据题目选择答案：", -1));
const _hoisted_5 = {
  key: 4,
  class: "colFlex bothCenter mt32"
};
const _hoisted_6 = {
  class: "answer-line"
};
const _hoisted_7 = {
  key: 1,
  class: "analysis-box"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "题目解析", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_row = _resolveComponent("el-row");
  const _component_TextAnalogyQuestion = _resolveComponent("TextAnalogyQuestion");
  const _component_TextLogicalReasoningQuestion = _resolveComponent("TextLogicalReasoningQuestion");
  const _component_AnswerButtonGroup = _resolveComponent("AnswerButtonGroup");
  return $props.data ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_2, "第" + _toDisplayString($props.data.questionIndex + 1) + "题", 1)]),
    _: 1
  }), $options.isAnalogy ? (_openBlock(), _createBlock(_component_TextAnalogyQuestion, {
    key: 0,
    question: $props.data.question,
    review: $props.review,
    "review-mode": $props.reviewMode,
    onChoose: $options.onAnalogyChoose
  }, null, 8, ["question", "review", "review-mode", "onChoose"])) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_hoisted_3, _createVNode(_component_TextLogicalReasoningQuestion, {
    question: $props.data.question
  }, null, 8, ["question"])], 64)), !$options.isAnalogy ? (_openBlock(), _createBlock(_component_el_row, {
    key: 2,
    class: "bothCenter mt32"
  }, {
    default: _withCtx(() => [_hoisted_4]),
    _: 1
  })) : _createCommentVNode("", true), !$options.isAnalogy ? (_openBlock(), _createBlock(_component_el_row, {
    key: 3,
    class: "bothCenter mt32"
  }, {
    default: _withCtx(() => [_createVNode(_component_AnswerButtonGroup, {
      onChoose: $options.onChoosed,
      review: $props.review,
      reviewMode: $props.reviewMode,
      options: $props.data.question.questionOption.split(',')
    }, null, 8, ["onChoose", "review", "reviewMode", "options"])]),
    _: 1
  })) : _createCommentVNode("", true), $props.reviewMode ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, "正确答案：" + _toDisplayString($options.correctAnswer), 1), $props.review ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "answer-line",
    style: _normalizeStyle({
      color: $props.review.result ? 'green' : 'red'
    })
  }, "您的答案：" + _toDisplayString($props.review.answer), 5)) : _createCommentVNode("", true), $props.data.question.analysisText ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_hoisted_8, _createElementVNode("p", null, _toDisplayString($props.data.question.analysisText), 1)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true);
}